import { TbCircleLetterP } from 'react-icons/tb';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useWorkReportModals } from '../../../../context/WorkReportModalsContext';
import { colorForProgramPoints, workReportLineStatus } from '../../../../utils/dataStatus';
import { Line } from '../../../../utils/globalPropTypes';

const ProgramPointsButton = ({
  line,
  selectedDate,
  setAmount,
  amount,
  disabledPPModal,
  setIsRectifyAmount,
  isRectifyAmount,
  setNewFetch
}) => {
  const { activeProgramPointModal } = useWorkReportModals();
  const [colorButtonPP, setColorButtonPP] = useState('#222222');
  const [disabledButton, setDisabledButton] = useState(true);

  useEffect(() => {
    if (line?.tienePuntosPrograma) {
      setColorButtonPP(colorForProgramPoints.withPP);
      setDisabledButton(false);
    } else if (
      line?.estadoEnum === workReportLineStatus.fijar ||
      line?.estadoEnum === workReportLineStatus.aprobar ||
      (line?.estadoEnum === workReportLineStatus.enviar &&
        !line.tienePuntosPrograma &&
        !isRectifyAmount) ||
      disabledPPModal ||
      line.bloqueadoEnSap
    ) {
      setColorButtonPP(colorForProgramPoints.disabledPP);
      setDisabledButton(true);
    } else {
      setColorButtonPP(colorForProgramPoints.withoutPP);
      setDisabledButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line]);

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      disabled={
        disabledButton ||
        ((line?.estadoEnum === workReportLineStatus.fijar ||
          line?.estadoEnum === workReportLineStatus.aprobar) &&
          !line?.tienePuntosPrograma) ||
        disabledPPModal ||
        line.bloqueadoEnSap
      }
      onClick={() => {
        activeProgramPointModal({
          line,
          selectedDate,
          setAmount,
          amount,
          disabledPPModal,
          tienePuntosPrograma: line?.tienePuntosPrograma,
          setIsRectifyAmount,
          isRectifyAmount,
          setNewFetch
        });
      }}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        cursor: !disabledButton ? 'pointer' : 'default'
      }}
      type="button"
    >
      <TbCircleLetterP color={colorButtonPP} size={25} />
    </button>
  );
};

export default ProgramPointsButton;

ProgramPointsButton.propTypes = {
  line: Line.isRequired,
  selectedDate: PropTypes.string.isRequired,
  setAmount: PropTypes.func,
  amount: PropTypes.number,
  disabledPPModal: PropTypes.bool,
  setIsRectifyAmount: PropTypes.func,
  isRectifyAmount: PropTypes.bool,
  setNewFetch: PropTypes.func
};

ProgramPointsButton.defaultProps = {
  disabledPPModal: false,
  amount: '',
  setAmount: () => {
    /* empty */
  },
  setIsRectifyAmount: () => {
    /* empty */
  },
  isRectifyAmount: false,
  setNewFetch: () => {
    /* empty */
  }
};
